import { render, staticRenderFns } from "./dingdingrelation.vue?vue&type=template&id=f17622c6&scoped=true&"
import script from "./dingdingrelation.vue?vue&type=script&lang=js&"
export * from "./dingdingrelation.vue?vue&type=script&lang=js&"
import style0 from "./dingdingrelation.vue?vue&type=style&index=0&id=f17622c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17622c6",
  null
  
)

export default component.exports